document.addEventListener('DOMContentLoaded', function() {
  console.log('faqs init...')

  var faqQuestion = $('.faq_question');

  const isOutOfViewport = function (elem) {
    // Get element's bounding
    const bounding = elem.getBoundingClientRect();
    const announcementBarHeight = document.querySelector('.announcement_bar') != null ? document.querySelector('.announcement_bar').clientHeight : 0;
    const headerHeight = document.querySelector('#section-header').clientHeight;
    const topVisibleLine = announcementBarHeight + headerHeight;
    let out = {};
  
  
    // Check if it's out of the viewport on each side
    // const elemTop = bounding.top - headerHeight - announcementBarHeight;
    const elemTop = bounding.top;
    out.top = elemTop < topVisibleLine;
    out.left = bounding.left < 0;
    out.bottom = bounding.bottom > (window.innerHeight || document.documentElement.clientHeight);
    out.right = bounding.right > (window.innerWidth || document.documentElement.clientWidth);
    out.any = out.top || out.left || out.bottom || out.right;
  
    return out;
  };

  const calcPositionTop = () => {
    const announcementBarHeight = $('.announcement_bar').length ? $('.announcement_bar').height() : 0;
    const headerHeight = $('#header').height();
    const wideScreenBuffer = announcementBarHeight + headerHeight + 20;
    const narrowScreenBuffer = announcementBarHeight + headerHeight - 5;

    const positionTop = $(window).outerWidth() > 1024 ? wideScreenBuffer : narrowScreenBuffer;

    return positionTop;
  };

  const showSelectedArticle = () => {
    if ($('#article_slug').length) {
      const articleSlug = $('#article_slug').val();
      const articleAccordion = $(`#${articleSlug}`);
      const accordionCategory = articleAccordion.parent().attr('id');
      // const faqCategory = accordionCategory.replace('accordion-', '');
  
      // $(`.faq_category[data-category="${faqCategory}"]`)[0].click();
  
      // collapse other questions
      $(`#${accordionCategory}`).find('.faq_question_title').addClass('collapsed').attr('aria-expanded', false);
      $(`#${accordionCategory}`).find('.faq_answer').removeClass('show');
  
      // show selected
      articleAccordion.find('.faq_question_title').removeClass('collapsed').attr('aria-expanded', true);
      articleAccordion.find('.faq_answer').addClass('show');
  
      const windowWidth = $(window).outerWidth();
      let scrollHeight = articleAccordion.position().top - calcPositionTop();
      scrollHeight = windowWidth > 1024 && windowWidth < 1200 ? scrollHeight + 20 : scrollHeight; // for desktop mid-width viewports
      $('html, body').stop(true, true).animate({ scrollTop:  scrollHeight}, 200);
  
      changeShowFaqArticle(articleAccordion);
    }
  };

  
  const scrollToTop = (el) => {


    if (el.find('.faq_question_title').hasClass('collapsed')) {
      const faqAnswer = el.find('.faq_answer');

      // check if the accordion is visible in the viewport after expanding.
      faqAnswer.on('shown.bs.collapse', (e) => {
        e.preventDefault();
        e.stopPropagation();

        setTimeout(() => {
          const windowWidth = $(window).outerWidth();
          let goScroll = true;
          let scrollBuffer = calcPositionTop();

          if (windowWidth > 1024) {
            const isAccordionOutOfViewport = isOutOfViewport(el[0]);
            goScroll = isAccordionOutOfViewport.top == true || isAccordionOutOfViewport.bottom == true;
            scrollBuffer -= 20;
          }

          if (goScroll) {
            $('html,body').animate({ scrollTop: el.offset().top - scrollBuffer }, 300);
          }

          $(e.currentTarget).off('shown.bs.collapse');
        }, 200);
      });

    }
};

  const replaceState = (url) => {
    window.history.replaceState({path: url}, '', url);
  };

  const changeShowFaqArticle = (el) => {
    const articleHandle = $(el).attr('id');
    const parentBlog = $(el).data('blog');
    let baseUrl;
  
    if (parentBlog) {
      baseUrl = window.location.protocol + '//' + window.location.host + '/blogs/' + parentBlog;
    } else {
      baseUrl = newUrl.length > 0 ? newUrl : window.location.protocol + '//' + window.location.host + selectedFaqCategoryHandle;
    }
  
    const articleUrl = baseUrl + '/' + articleHandle;
  
    replaceState(articleUrl);
  };

  faqQuestion.on('click', (ev) => {
    const _this = $(ev.currentTarget);
    const windowWidth = $(window).outerWidth();
    ev.preventDefault();
  
    changeShowFaqArticle(_this);
    scrollToTop(_this);
  });

  showSelectedArticle();
})